const portfolioData = [
    { 
        id: 1,
        title: 'Hotel Booking App',
        img: './images/Screenshot (73).webp',
        writeup: "A project I came across in a friend's portfolio. Creating this project I made use of a dynamic page and dommy data calls. This project was also created using the power of Reactjs.",
        site: 'https://anointedosara-hotel-room-booking.netlify.app/',
        project: 'https://github.com/anointedosara/home-room-booking'
    },
    { 
        id: 2,
        title: 'Movie App',
        img: './images/Screenshot (72).webp',
        writeup: 'A personal project also based on a design I saw online. This app gives you link to the trailer of trending movies and tv-series on youtube. It was created using Reactjs and RestfulApi.',
        site: 'https://anointedosara-movie-app.netlify.app/',
        project: 'https://github.com/anointedosara/movie-app'
    },
    { 
        id: 3,
        title: 'E-commerce Landing Page',
        img: './images/Screenshot (75).webp',
        writeup: 'A very responsive project based on a design I got on Frontend Mentor. It was created using raw Html, Css and JavaScript and no frameworks.',
        site: 'https://anointedosara.github.io/ecommerce-product-page/',
        project: 'https://github.com/anointedosara/ecommerce-product-page'
    },
    { 
        id: 4,
        title: 'Calculator App',
        img: './images/Screenshot (78).webp',
        writeup: 'Also a very responsive project based on a design I got on Frontend Mentor. It was created using raw Html, Css and JavaScript and no frameworks.',
        site: 'https://anointedosara.github.io/calculator-app/',
        project: 'https://github.com/anointedosara/calculator-app'
    },
    { 
        id: 5,
        title: 'Rest Countries Api',
        img: './images/Screenshot (80).webp',
        writeup: 'Based off on a challenge on Front-End Mentors. I finished the project which I employed my knowledge of RESTFul APIs and made several get requests to the countries RESTFul api and populated the page with the data gotten from it.',
        site: 'https://anointedosara.github.io/rest-countries-api/',
        project: 'https://github.com/anointedosara/rest-countries-api'
    },
    { 
        id: 6,
        title: 'Weebly',
        img: './images/Screenshot (84).webp',
        writeup: 'I and a friend of mine worked on this Weebly landing page together to test our Github pull request ability, he created the Marketing Page. The first page is all me created using Html, Css and JavaScript.',
        site: 'https://anointedosara.github.io/weebly/',
        project: 'https://github.com/anointedosara/weebly'
    },
    { 
        id: 7,
        title: 'IP Address Tracker',
        img: './images/Screenshot (79).webp',
        writeup: 'The ideaof this project was gotten from a challenge on Front-End Mentor. I made use of RESTFul APIs and Map Api given to me by Front-End Mentor.',
        site: 'https://anointedosara.github.io/ip-address-tracker-master/',
        project: 'https://github.com/anointedosara/ip-address-tracker-master'
    },
    { 
        id: 8,
        title: 'Bookmark Landing Page',
        img: './images/Screenshot (81).webp',
        writeup: 'A very responsive project based on a design I got on Frontend Mentor. It was created using raw Html, Css and JavaScript and no frameworks.',
        site: 'https://anointedosara.github.io/bookmark-landing-page-master/',
        project: 'https://github.com/anointedosara/bookmark-landing-page-master'
    },
    { 
        id: 9,
        title: 'Room Homepage',
        img: './images/Screenshot (83).webp',
        writeup: 'A personal and very responsive projects using Html, Css and JavaScript to build a basic Room Homepage. The design was also gotten from Front-End Mentor.',
        site: 'https://anointedosara.github.io/room-homepage-master/',
        project: 'https://github.com/anointedosara/room-homepage-master'
    },
    { 
        id: 10,
        title: 'Realtime Chat App',
        img: './images/Screenshot (71).webp',
        writeup: 'A personal, and very responsive project based on a design I saw online. Using the power of Reactjs state management, I created Real-Time-Chat-App.',
        site: 'https://anointedosara-chat-app.netlify.app/',
        project: 'https://github.com/anointedosara/chat-app'
    },
    {
        id: 11,
        image: '../images/carbon_earth.png',
        skill: 'WEB DEVELOPMENT',
        speech: 'A very professional front-end web developer with enthusiasm for Full Stack Web Development.'
    },
    {
        id: 12,
        image: '../images/pixel.png',
        skill: 'PIXEL PERFECT',
        speech: 'All my works are pixel perfect and they match design with 100% conversion.'
    },
    {
        id: 13,
        image: '../images/responsive.png',
        skill: 'RESPONSIVENESS',
        speech: 'All my works are responsive on all screensizes from small to extra large screensizes.'
    },
    {
        id: 14,
        image: '../images/react.png',
        skill: 'REACTJS',
        speech: 'I also come with sound knowledge and experience in Reactjs and its important plugins.'
    },
    {
        id: 15,
        image: '../images/design.png',
        skill: 'MORE THAN DESIGN',
        speech: "I also don't just do the design part of front end, I develop using Javascript, Jquery, APIs and more."
    },
    {
        id: 16,
        image: '../images/learn.png',
        skill: 'LEARNING CULTURE',
        speech: "I never settle for less. I'm always looking to learn new technologies and quickly too."
    }
]

export default portfolioData